import React, { useState, useEffect, useRef } from 'react';
import Modal                          from 'react-bootstrap/Modal';
import CloseBtn                       from 'assets/icons/Close.svg';
import GuaranteeLetterService         from 'services/guarantee-letter.service';
import AuthService                    from 'services/auth.service';
import queryString                    from 'query-string';
import RedCheck                       from 'assets/icons/Red Check.svg';
import GreenTick                      from 'assets/icons/Green Tick.svg';
import CancelIcon                     from 'assets/icons/Cancel Icon.svg';
import FileIcon                       from 'assets/icons/Uploaded File.svg';

export function GuaranteeLetterEdit(props) {
  const [show, setShow]                   = useState(false);
  const handleShow                        = () => setShow(true);
  const [sectionOne, setSectionOne]       = useState(true);
  const [sectionTwo, setSectionTwo]       = useState(false);
  const [errorIcon, setErrorIcon]         = useState(RedCheck);
  const [errorMsg, setErrorMsg]           = useState('This patient is not entitled for employee benefit.');
  const [errorHeader, setErrorHeader]     = useState('No ID Found');

  const handleClose = () => {
    setShow(false);
    setSectionOne(true);
    setSectionTwo(false);
    setErrorIcon(RedCheck);
    setErrorMsg('This patient is not entitled for employee benefit.');
    setErrorHeader('No ID Found');
    setErrorResponse('');
    setAttachedFile([]);
  };

  // Submitting NRIC to API to retrieve employee info.

  // Insurance List.
    const [insurerOptions, setInsurerOptions] = useState([]);
    const practiceLocation                    = AuthService.getPracticeLocation();

    useEffect(() => {
      let parameters;

      parameters = queryString.stringify({
        practice_location_id: practiceLocation.id
      });

      GuaranteeLetterService.insuranceList(parameters).then(
        (data) => {
          const options = data.insurances.map((hash, index) => {
            return (
              <option key={ index } value={ hash.id }>{ hash.name }</option>
            )
          });

          setInsurerOptions(options);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Received information from props.
    const [displayInfoTwo, setDisplayInfoTwo] = useState(<span></span>);
    const [nricDisplay]                       = useState(props?.details?.nric);
    const [insurerField, setInsurerField]     = useState(props?.details?.insurer_id);
    const [doctypeField, setDoctypeField]     = useState(props?.details?.doctype);
    const [noteField, setNoteField]           = useState(props?.details?.notes);
    const [documents, setDocuments]           = useState(props?.details?.documents);
    const [displayDocs, setDisplayDocs]       = useState(<span>None</span>);
    const [removedDocs, setRemovedDocs]       = useState([]);

    // Need to reload on opening, for some reason it doesn't pass immediately.
    useEffect(() => {
      setDocuments(props?.details?.documents);
    }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      const patientInfo = [
        { title: 'Email',       value: props?.details?.email },
        { title: 'Full Name',   value: props?.details?.name },
        { title: 'Phone',       value: props?.details?.phone }
      ];

      var infoList = patientInfo;
      if (infoList.length === 0) { return }

      const byChunks = infoList.reduce((memo, value, index) => {
        if (index % 2 === 0 && index !== 0) memo.push([])
        memo[memo.length - 1].push(value)
        return memo
      }, [[]]);

      const informationRows = byChunks.map((array, index) => {
        return (
          <div className="row" key={ index }>
            <div className="col">
              <p className="text-left text-lightgrey mb-0">{ array[0]?.title }</p>
              <p className="text-left"><b>{ array[0]?.value || '-'  }</b></p>
            </div>

            <div className="col">
              <p className="text-left text-lightgrey mb-0">{ array[1]?.title }</p>
              <p className="text-left"><b>{ array[1] ? (array[1]?.value || '-') : null }</b></p>
            </div>
          </div>
        )
      });

      setDisplayInfoTwo(informationRows);

      const removeDocument = (id) => {
        let newRemovedDocs  = removedDocs.slice();
        var index           = newRemovedDocs.indexOf(id);

        if (index !== -1) {
          newRemovedDocs.splice(index, 1);
        } else {
          newRemovedDocs.push(id);
        }

        setRemovedDocs(newRemovedDocs);
      };

      const document_icons = documents.map((file) => {
        const document_name = file.url.replace(/^.+\/documents\//, '');
        const docName = removedDocs.includes(file.id) ? <del>{ document_name }</del> : document_name;

        return (
          <div className="d-flex align-items-center mb-4" key={ file.id }>
            <a href={ file?.url } target="_blank" rel="noreferrer" className="text-danger">
              <p className="font-size-4 mb-0">
                <img src={ FileIcon } alt="view-letter" className="clickable mr-4" />
                  { docName }
              </p>
            </a>

            <img src={ CancelIcon } alt="remove-attachment" className="clickable ml-4 w-em-5" onClick={(e) => removeDocument(file.id) } />
          </div>
        )
      });

      setDisplayDocs(
        <div className="d-flex mb-4">
          <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">Uploaded File<br/></div>
          <div>{ document_icons }</div>
        </div>
      );
    }, [removedDocs, documents]); // eslint-disable-line react-hooks/exhaustive-deps

  // Submit action.
    const refreshGuaranteeLetters             = () => props.handleReload();
    const [attachedFile, setAttachedFile]     = useState([]);
    const [submitBtn, setSubmitBtn]           = useState(<button>Submit</button>);
    const [errorResponse, setErrorResponse]   = useState('');
    const [disabledSubmit, setDisabledSubmit] = useState(false);

    useEffect(() => {
      const handleSubmit = () => {
        const formData = new FormData();

        // 2021-08-17 - Reuben says insurer should be optional.
        // if (insurerField.length < 1) {
        //   setErrorResponse('You must select an insurance');
        //   return;
        // }

        if (doctypeField.length < 1) {
          setErrorResponse('You must select a document type');
          return;
        }

        formData.append('guarantee_letter[insurance_id]', insurerField);
        formData.append('guarantee_letter[document_type]', doctypeField);
        formData.append('guarantee_letter[notes]', noteField);

        if (attachedFile.length > 0) {
          attachedFile.forEach(function(file, index) {
            formData.append('guarantee_letter[doctor_upload_documents_attributes][' + index + '][file]', file, file.name);
          });
        }

        if (removedDocs.length > 0) {
          removedDocs.forEach(function(id) {
            formData.append('guarantee_letter[doctor_upload_documents_attributes][' + id + '][id]', id);
            formData.append('guarantee_letter[doctor_upload_documents_attributes][' + id + '][_destroy]', '1');
          });
        }

        setDisabledSubmit(true);

        GuaranteeLetterService.updateGuaranteeLetter(formData, props?.details?.id).then(
          (data) => {
            setErrorIcon(GreenTick);
            setErrorHeader('Guarantee letter registered');
            setErrorMsg('A new guarantee letter has been opened for this employee.');
            setSectionOne(false);
            setSectionTwo(true);
            setTimeout(refreshGuaranteeLetters, 1500);
          },
          (error) => {
            console.log(error.response);

            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            }
          }
        );

        setTimeout(() => { setDisabledSubmit(false) }, 4000);
      }

      setSubmitBtn(
        <button className="btn btn-danger text-white rounded-pill py-3 px-20" onClick={() => { handleSubmit() }} disabled={ disabledSubmit } >
          Submit
        </button>
      );
    }, [insurerField, doctypeField, noteField, attachedFile, disabledSubmit, removedDocs]); // eslint-disable-line react-hooks/exhaustive-deps

  // File Upload
    const hiddenFileInput             = useRef();
    const [fileInputs, setFileInputs] = useState(<span></span>);

    const handleFileClick = (event) => {
      hiddenFileInput.current.click();
    };

    const checkFileFormat = (file) => {
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      setErrorResponse('');

      if (!file) { return }

      if (!allowedTypes.includes(file.type)) {
        setErrorResponse('File type can only be JPEG, JPG, PNG or PDF');
      } else if (file.size > 4000000) {
        setErrorResponse('File size exceeds 4MB');
      } else {
        let allFiles    = attachedFile.slice();
        allFiles.push(file);
        setAttachedFile(allFiles);
      }
    };

    useEffect(() => {
      const removeFileSection = (e, index) => {
        let allFiles    = attachedFile.slice();
        allFiles.splice(index, 1);
        setAttachedFile(allFiles);
      };

      const fileInputFields = attachedFile.map((file, index) => {
        return (
          <div className="file-input-field-section" key={ index }>
            <p className="font-size-4 mt-2 text-danger">
              <img src={ FileIcon } alt="file-icon" className="mr-4" />
              { file.name }
              <img src={ CancelIcon } alt="remove-attachment" className="clickable ml-4 w-em-5" onClick={(e) => removeFileSection(e, index) } />
            </p>
          </div>
        )
      });

      setFileInputs(
        <div className="font-size-6 flex-grow-1 pt-3">
          { fileInputFields }
          <input type="file" onChange={(e) => checkFileFormat(e.target.files[0]) } value="" className="d-none" ref={ hiddenFileInput } />
          <span className="fweight-400 clickable text-danger" onClick={ handleFileClick }>Add File</span>
        </div>
      );
    }, [attachedFile]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="action-child px-4 py-4" onClick={ handleShow }>Edit</div>

      <Modal show={ show } onHide={ handleClose } keyboard={ false } size="lg" centered>
        <Modal.Header className="d-block">
          <h3>Edit GL Form</h3>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body className="d-block">
          <div className="conditional-display" displayed={ sectionOne.toString() }>
            <div className="font-size-8 fweight-400 w-em-26 pt-3 pr-4">Patient Information</div>

            <div className="d-flex">
              <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">Patient IC/Passport No.</div>

              <div className="font-size-6 fweight-400 flex-grow-1">
                <div className="pt-4">
                  { nricDisplay }
                </div>
              </div>
            </div>

            <div className="conditional-display mt-8">
              { displayInfoTwo }
            </div>

            <hr/>

            <div className="conditional-display mt-4">
              <div className="d-flex mb-4">
                <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">Insurer</div>

                <div className="font-size-6 fweight-400 flex-grow-1">
                  <select className="form-control rounded-pill px-4" value={ insurerField } onChange={(e) => setInsurerField(e.target.value) }>
                    <option>-</option>
                    { insurerOptions }
                  </select>
                </div>
              </div>

              <div className="d-flex mb-4">
                <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">Document Type</div>

                <div className="font-size-6 fweight-400 flex-grow-1">
                  <select className="form-control rounded-pill px-4" value={ doctypeField } onChange={(e) => setDoctypeField(e.target.value) }>
                    <option>-</option>
                    <option value="outpatient_specialist">Outpatient Specialist</option>
                    <option value="admission_form">Admission Form</option>
                    <option value="discharge_form">Discharge Form</option>
                  </select>
                </div>
              </div>

              <div className="d-flex mb-4">
                <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">Note</div>

                <div className="font-size-6 fweight-400 flex-grow-1">
                  <textarea name="doctor-note" type="area" rows="4"
                    placeholder="Explain the patient's health condition."
                    className="form-control py-3 px-4"
                    value={ noteField }
                    onChange={(e) => setNoteField(e.target.value) }
                    style={{ borderRadius: "1em" }}
                  />
                </div>
              </div>

              { displayDocs }

              <div className="d-flex mb-4">
                <div className="font-size-7 fweight-400 w-em-26 pt-3 pr-4">
                  Upload File <span className="fweight-300">(Optional)</span><br/>

                  <span className="font-size-2">
                    File can be in either JPEG, JPG, PNG or PDF formats. <br/>Size limit is 4MB.
                  </span>
                </div>

                { fileInputs }
              </div>
            </div>

            <div className="text-center mt-20">
              <p className="text-left text-danger fweight-400 mb-6">{ errorResponse }</p>
              { submitBtn }
            </div>
          </div>

          <div className="conditional-display text-center" displayed={ sectionTwo.toString() }>
            <img src={ errorIcon } alt="error-check"/>
            <h3 className="text-center text-danger my-6">{ errorHeader }</h3>
            <p className="text-center text-grey mb-10">{ errorMsg }</p>
            <button className="btn btn-danger text-white rounded-pill py-3 px-20" onClick={ handleClose }>OKAY</button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}